export const mobileMixins = {
  data(){
    return {
      isMobile: this.$isMobile,
      isMinMobile: this.$isMinMobile,
    }
  },
  mounted(){
    window.addEventListener('setItemEvent',(e) => {
      if(e.key == 'isMobile'){
        this.isMobile = e.newValue;
      }
      if(e.key == "isMinMobile"){
        this.isMinMobile = e.newValue;
      }
    })
  },
}